import { ROUTES, buildRoute } from '@/constants/routes';

/** Rutas de backoffice para gestionar prácticas de conversación. */
export const conversationBackofficeRoutes = {
  list: ROUTES.BACKOFFICE.CONVERSATIONS,
  create: ROUTES.BACKOFFICE.CONVERSATION_CREATE,
  edit: (id: string) => buildRoute(ROUTES.BACKOFFICE.CONVERSATION_EDIT, { id }),
  contentIndex: (resourceId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_CONTENT, { resourceId }),
  contentNew: (resourceId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_CONTENT_CREATE, { resourceId }),
  contentEdit: (resourceId: string, contentId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_CONTENT_EDIT, { resourceId, contentId }),
  activitiesIndex: (resourceId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_ACTIVITIES, { resourceId }),
  activityNew: (resourceId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_ACTIVITY_CREATE, { resourceId }),
  activityEdit: (resourceId: string, activityId: string) =>
    buildRoute(ROUTES.BACKOFFICE.CONVERSATION_ACTIVITY_EDIT, { resourceId, activityId }),
} as const;
